import { render, staticRenderFns } from "./Thank-you-quote.vue?vue&type=template&id=2154f27c&"
import script from "./Thank-you-quote.vue?vue&type=script&lang=js&"
export * from "./Thank-you-quote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports